import { render, staticRenderFns } from "./ResultSuccess.vue?vue&type=template&id=67360684&scoped=true&"
import script from "./ResultSuccess.vue?vue&type=script&lang=js&"
export * from "./ResultSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ResultSuccess.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ResultSuccess.vue?vue&type=style&index=1&id=67360684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67360684",
  null
  
)

export default component.exports